import React, {Component, Fragment} from 'react';
import '../css/CalculatorForm.css';
import calcData from '../json/calcData.json';
import FormValidator from '../validation/FormValidator';
import axios from 'axios';
import Disclaimer from './Disclaimer';

class CalculatorForm extends Component {
	constructor(props) {
		super(props);

		this.validator = new FormValidator(props.config.lang);
		this.state = {
			currentheating: '',
			annualspend: '',
			province: '',
			firstname: '',
			lastname: '',
			emailaddress: '',
			postalcode: '',
			caslcheck: '',
			savings: '',
			validation: this.validator.valid()
		};
		this.submitted = false;
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	buildDropdown() {
		const dropdownList = [];

		dropdownList.push(<option value="" key="noProv">{this.props.content.selectPrompt}</option>);

		for (let method in calcData.heating) {
			method = calcData.heating[method];
			const methodName = this.props.config.lang === "en"
				? method.name
				: method.nameFr;

			if (method.id === 100)
				continue;

			dropdownList.push(<option value={method.id} key={method.id}>{methodName}</option>);
		}

		return dropdownList;
	}

	costPerMBTU(jsonIndex) {
		for (let method in calcData.heating) {
			let cost;
			method = calcData.heating[method];

			if (method.id !== jsonIndex)
				continue;

			for (let province in calcData.costs) {
				if (province === this.state.province) {
					cost = parseFloat(calcData.costs[province][method.fuel]);
					break;
				}
			}

			const costPerMBTU = (((1000000 / parseFloat(method.efficiency)) / method.btuPerUnit) * (cost / 100));
			return costPerMBTU;
		}
	}

	handleChange(event) {
		if (event.target.type !== 'checkbox') {
			event.preventDefault();
			this.setState({
				[event.target.name]: event.target.value
			});
		} else {
			this.setState({
				[event.target.name]: event.target.checked.toString()
			});
		}
	}

	handleSubmit(event) {
		event.preventDefault();
		this.submitted = true;
		const validation = this.validator.validate(this.state);
		this.setState({validation});

		if (validation.isValid) {
			const totalBTU = this.state.annualspend / this.costPerMBTU(parseInt(this.state.currentheating, 10));
			// 100 = arbitrary id for heat pump control
			const savings = this.state.annualspend - (this.costPerMBTU(100) * totalBTU);

			// Request is sent + Next page is displayed in the set state callback to ensure that the savings are set
			this.setState({
				savings: savings.toFixed(0)
			}, () => {
				const result = {
					savings: this.state.savings
				};

				this.props.addResult(result);
				if (!this.props.formSubmitted) {
					let data = new FormData();

					let dealerId = parseInt( this.props.config.dealerId, 10 );
					if ( isNaN(dealerId) || dealerId <= 1 ) {
						dealerId = 'NO-ID';
					}

					let heatingname = '';
					Object.keys(calcData.heating).forEach(key => {
						if (calcData.heating[key].id.toString() === this.state.currentheating) {
							heatingname = `${calcData.heating[key].name}`;
						}
					});

					data.append('lead_firstname', this.state.firstname);
					data.append('lead_lastname', this.state.lastname);
					data.append('lead_email', this.state.emailaddress);
					data.append('lead_province', this.state.province);
					data.append('lead_postalcode', this.state.postalcode);
					data.append('lead_source', this.props.config.dealerUrl);
					data.append('lead_dealer', dealerId);
					data.append('lead_dealername', this.props.config.dealerName);
					data.append('lead_annualspend', this.state.annualspend);
					data.append('lead_home_heating', heatingname);
					data.append('lead_savingamount', this.state.savings);
					data.append('lead_casl', true);
					data.append('lead_submit', true);
					data.append('emco_calculator_submission', true);
					data.append('language', this.props.config.lang);

					const envUrl = this.props.config.env === 'dev'
						? 'https://daikinatlantic.ca/'
						: '';

					let options = {
						method: 'POST',
						headers: {
							'Content-Type': 'multipart/form-data'
						},
						contentType: false,
						processData: false,
						data: data,
						url: envUrl
					};
					axios(options).catch().then();
				}
				this.props.viewResult(true);

				window.dataLayer = window.dataLayer || [];

				window.dataLayer.push({'event' : 'savingsCalcSubmitted'});
			});
		}
	}

	render() {
		let width = this.props.dimensions.width;
		const classes = (width >= 684)
			? "app__responsive-row app__emco-wide"
			: "app__responsive-row";

		const envUrl = this.props.config.env === 'dev'
			? 'https://daikinatlantic.ca/'
			: '';

		const policyUrl = this.props.config.lang === 'en'
			? `${envUrl}privacy-policy/`
			: `${envUrl}politique-de-confidentialite/?lang=fr`;

		let validation = this.submitted
			? // if the form has been submitted at least once
			this.validator.validate(this.state)
			: // then check validity every time we render
			this.state.validation; // otherwise just use what's in state

		return (
			<Fragment>
				<div className="app__form-wrap">
					<form className="app__form" onSubmit={this.handleSubmit} noValidate="noValidate">
						<div className={classes}>
							<div className="app__responsive-wrap app__emco_col_6">
								<div className="app__form-group">
									<label htmlFor="emco_firstname">
										{this.props.content.fnameLabel}
										<input className={"app__form-input " + (
												validation.firstname.isInvalid
												? "app__form-input--error"
												: "")} type="text" id="emco_firstname" name="firstname" onChange={this.handleChange}/>
									</label>
									<div className="app__form--error">{validation.firstname.message}</div>
								</div>
								<div className="app__form-group">
									<label htmlFor="emco_lastname">
										{this.props.content.lnameLabel}
										<input className={"app__form-input " + (
												validation.lastname.isInvalid
												? "app__form-input--error"
												: "")} type="text" id="emco_lastname" name="lastname" onChange={this.handleChange}/>
									</label>
									<div className="app__form--error">{validation.lastname.message}</div>
								</div>
								<div className="app__form-group">
									<label htmlFor="emco_emailaddress">
										{this.props.content.emailLabel}
										<input className={"app__form-input " + (
												validation.emailaddress.isInvalid
												? "app__form-input--error"
												: "")} type="text" id="emco_emailaddress" name="emailaddress" autoCapitalize="none" onChange={this.handleChange}/>
									</label>
									<div className="app__form--error">{validation.emailaddress.message}</div>
								</div>
								<div className="app__form-group">
									<label htmlFor="emco_postalcode">
										{this.props.content.postalCode}
										<input className={"app__form-input " + (
												validation.postalcode.isInvalid
												? "app__form-input--error"
												: "")} type="text" id="emco_postalcode" name="postalcode" autoCapitalize="none" onChange={this.handleChange}/>
									</label>
									<div className="app__form--error">{validation.postalcode.message}</div>
								</div>
							</div>
							<div className="app__responsive-wrap app__emco_col_6">
								<div className="app__form-group">
									<label htmlFor="emco_currentheating">
										{this.props.content.currentHeatingLabel}
									</label>
									<select className={"app__form-select " + (
											validation.currentheating.isInvalid
											? "app__form-select--error"
											: "")} id="emco_currentheating" name="currentheating" value={this.state.currentheating} onChange={this.handleChange}>
										{this.buildDropdown()}
									</select>
									<div className="app__form--error">{validation.currentheating.message}</div>
								</div>
								<div className="app__form-group">
									<label htmlFor="emco_annualspend">
										{this.props.content.annualSpendLabel}
									</label>
									<input className={"app__form-input " + (
											validation.annualspend.isInvalid
											? "app__form-input--error"
											: "")} type="number" min="0" max="20000" name="annualspend" id="emco_annualspend" onChange={this.handleChange} inputMode="numeric" />
									<div className="app__form--error">{validation.annualspend.message}</div>
								</div>
								<div className="app__form-group">
									<label htmlFor="emco_province">
										{this.props.content.provLabel}
									</label>
									<select className={"app__form-select " + (
											validation.province.isInvalid
											? "app__form-select--error"
											: "")} id="emco_province" name="province" value={this.state.province} onChange={this.handleChange}>
										<option value="">{this.props.content.selectPrompt}</option>
										<option value="NB">{this.props.content.nb}</option>
										<option value="NL">{this.props.content.nl}</option>
										<option value="NS">{this.props.content.ns}</option>
										<option value="PE">{this.props.content.pe}</option>
									</select>
									<div className="app__form--error">{validation.province.message}</div>
								</div>
								<div className="app__form-group app__form-group--casl">
									<input id="emco_caslcheck_id" className="app__form-checkbox" type="checkbox" name="caslcheck" onChange={this.handleChange}/>
									<label className="app__casl-label" htmlFor="emco_caslcheck_id">
										{this.props.content.caslcheck}
										<a href={policyUrl}>{this.props.content.policy}</a>
									</label>
									<div className="app__form--error">{validation.caslcheck.message}</div>
								</div>
							</div>
						</div>
						<div className={classes}>
							<div className="app__responsive-wrap app__form-submit-wrap">
								<input type="submit" value={this.props.content.submitLabel}/>
							</div>
						</div>
					</form>
				</div>
				<Disclaimer config={this.props.config} content={this.props.disclaimer} lang={this.props.config.lang}/>
			</Fragment>
		);
	}
}

export default CalculatorForm;



// WEBPACK FOOTER //
// ./src/components/CalculatorForm.js